import type { IPatientSchedule } from 'features/Home/interfaces/IInfoSchedule'
import { resolveScheduleRoomId } from './helpers'
import { MAX_STACKED_STAFF_BADGES } from './StaffInitialsStack'
import {
  getScheduleStaffColor,
  getScheduleStaffId,
  isWaitingRoomSchedule,
} from './scheduleInstance'

export const applyStaffColorToken = (
  element: HTMLElement,
  event: Pick<IPatientSchedule, 'consultation_staff'> & { joint_providers?: { id: number }[] },
): void => {
  const color = getScheduleStaffColor(getScheduleStaffId(event))
  element.style.setProperty('--staff-color', color)
  element.style.setProperty('--staff-color-ink', '#fff')
  // Slots below the primary take their own doctor's color; an unused slot is cleared.
  Array.from({ length: MAX_STACKED_STAFF_BADGES - 1 }, (_, index) => index + 1).forEach((slot) => {
    const provider = event.joint_providers?.[slot]
    if (provider)
      element.style.setProperty(`--staff-color-${slot}`, getScheduleStaffColor(provider.id))
    else element.style.removeProperty(`--staff-color-${slot}`)
  })
}

export const applyStaffFocus = (
  element: HTMLElement,
  event: Pick<IPatientSchedule, 'consultation_staff' | 'room' | 'room_id'> & {
    room_type_id?: number
    joint_providers?: { id: number }[]
  },
  focusedStaffIds: number[] | null | undefined,
  waitingRoomResourceId?: string,
): void => {
  const inWaitingRoom =
    isWaitingRoomSchedule(event) ||
    (Boolean(waitingRoomResourceId) &&
      resolveScheduleRoomId(event.room_id) === waitingRoomResourceId)

  if (!focusedStaffIds?.length || inWaitingRoom) {
    element.classList.remove('schedule-event--dim', 'schedule-event--focus')
    return
  }

  // A joint card belongs to every doctor on it.
  const staffIds = event.joint_providers?.map((provider) => provider.id) ?? [
    getScheduleStaffId(event),
  ]
  const on = staffIds.some((id) => focusedStaffIds.includes(id))
  element.classList.toggle('schedule-event--dim', !on)
  element.classList.toggle('schedule-event--focus', on)
}
